/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Cookies from 'js-cookie';

export const Authorize= ()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const auth =  urlParams.get("auth");
    const id = urlParams.get("id");


    const checkKey = async ()=>{
        const url= "api/index.php/auth/getAuthKey?id="+id+"&auth="+auth;
        fetch (url,{
            method:"GET"
        }).then(response=>{
            console.log(response);
            if (response.ok){
                response.json().then(async data=> {
                const future = new Date();
                future.setDate(future.getDate() + 1);
                Cookies.set("nsj_access",data,{expires:future});   
                }) 
            }
            window.location.replace("/");

        })
    }

    useEffect(()=>{
        console.log("Auth:")
        console.log(auth);
        console.log("Id:")
        console.log(id);
        if (id){
            if (auth){
                checkKey().then(data=>{
                    console.log(data);
                    console.log(document.cookie);
                })
            }else{
                console.log("Error: Authorization key missing");
            }

        }else{
            console.log("Error: Id parameter missing");
        }

    },[])
    return(
        <></>
    )
}